import swal from 'sweetalert';

export default class ModalService {

  static openAlert(title, msg, suceess) {
    swal(title, msg, suceess);
  }

  static openAlertWithPopup(title, msg, type, buttons, cb) {
    swal({
      title,
      text: msg,
      icon: type,
      buttons
    })
      .then((isConfirm) => {
        if (isConfirm) {
          return cb(true);
        }
        return cb(false);
      });
  }

}